const xhLeft = 110
const xhCenter = 300
const xhRight = 485

const xvLeft = -9
const xvRight = 542

const yhTop = -8
const yhBottom = 536

const yvTop = 155
const yvCenter = 298
const yvBottom = 440

export const shapes = {
    rectangle: {
        icon: "M -2.5e-5,-2.405e-5 V 50.000024 h 50.00005 V -2.405e-5 Z m 2.99982,2.99981695 h 44.00042 V 47.000207 H 2.999795 Z",
        path: "M 10,10 V 720 H 970 V 10 Z M 25,25 H 955 V 705 H 25 Z",
        viewBox: "0 0 980 730",
        patternTransform: "rotate(-45) translate(15)",
        dimensions: [
            {prop: "a", position: "top", x: xhCenter, y: yhTop},
            {prop: "b", position: "right", x: xvRight, y: yvCenter},
        ]
    },
    open: {
        icon: "m -2.5e-5,-2.4e-5 v 50.000048 h 2.99982 V 47.000207 24.379366 2.999793 h 44.000413 v 21.379573 22.620841 2.999817 h 2.999817 V -2.4e-5 Z",
        path: "M 970,720 V 10 H 10 V 720 H 25 V 25 h 930 v 695 z",
        viewBox: "0 0 980 730",
        patternTransform: "rotate(-45) translate(15)",
        dimensions: [
            {prop: "a", position: "top", x: xhCenter, y: yhTop},
            {prop: "b", position: "right", x: xvRight, y: yvCenter},
            {prop: "c", position: "left", x: xvLeft, y: yvCenter},
        ],
    },
    l_form_a: {
        icon: "M 50.000024,22.00018 H 27.999814 V -1.95e-5 H 24.999999 -2.45e-5 V 50.000019 H 50.000024 V 25 Z M 47.000204,25 V 47.000201 H 2.9997925 V 2.9997905 H 25 V 25.000001 Z",
        path: "M 10,10 V 720 H 970 V 360 H 515 V 10 Z M 25,25 H 500 V 375 H 955 V 705 H 25 Z",
        viewBox: "0 0 980 730",
        patternTransform: "rotate(-45) translate(15)",
        dimensions: [
            {prop: "a", position: "top", x: xhLeft, y: yhTop},
            {prop: "b", position: "right", x: xvRight, y: yvBottom},
            {prop: "c", position: "bottom", x: xhCenter, y: yhBottom},
            {prop: "d", position: "left", x: xvLeft, y: yvCenter},
        ]
    },
    l_form_b: {
        icon: "m 22.000185,-2.5e-5 v 22.00021 H -2.5e-5 v 2.99981 25.00003 h 50.00005 V -2.5e-5 H 24.999994 Z m 2.999809,2.99982 h 22.000211 v 44.00041 H 2.999795 v -22.00021 h 22.000199 z",
        path: "M 970,10 V 720 H 10 V 360 H 465 V 10 Z M 955,25 H 480 V 375 H 25 v 330 h 930 z",
        viewBox: "0 0 980 730",
        patternTransform: "rotate(-45) translate(15)",
        dimensions: [
            {prop: "a", position: "top", x: xhRight, y: yhTop},
            {prop: "b", position: "right", x: xvRight, y: yvCenter},
            {prop: "c", position: "bottom", x: xhCenter, y: yhBottom},
            {prop: "d", position: "left", x: xvLeft, y: yvBottom},
        ]
    },
    l_form_c: {
        icon: "M 27.999817,50.000029 V 27.999811 h 22.00021 V 24.999991 -2.9e-5 H -2.65e-5 V 50.000029 H 24.999997 Z m -2.99982,-2.999818 H 2.9997935 V 2.999791 H 47.000207 v 22.0002 h -22.00021 z",
        path: "M 10,720 V 10 H 970 V 370 H 515 V 720 Z M 25,705 H 500 V 355 H 955 V 25 H 25 Z",
        viewBox: "0 0 980 730",
        patternTransform: "rotate(-45) translate(15)",
        dimensions: [
            {prop: "a", position: "top", x: xhCenter, y: yhTop},
            {prop: "b", position: "right", x: xvRight, y: yvTop},
            {prop: "c", position: "bottom", x: xhLeft, y: yhBottom},
            {prop: "d", position: "left", x: xvLeft, y: yvCenter},
        ]
    },
    l_form_d: {
        icon: "M -2.35e-5,27.999816 H 22.000184 v 22.000209 h 2.99982 25.000019 V -2.45e-5 H -2.35e-5 V 24.999996 Z m 2.99982,-2.99982 V 2.9997855 H 47.000213 V 47.000205 H 25.000004 v -22.00021 z",
        path: "M 970,720 V 10 H 10 V 370 H 465 V 720 Z M 955,705 H 480 V 355 H 25 V 25 h 930 z",
        viewBox: "0 0 980 730",
        patternTransform: "rotate(-45) translate(15)",
        dimensions: [
            {prop: "a", position: "top", x: xhCenter, y: yhTop},
            {prop: "b", position: "right", x: xvRight, y: yvCenter},
            {prop: "c", position: "bottom", x: xhRight, y: yhBottom},
            {prop: "d", position: "left", x: xvLeft, y: yvTop},
        ]
    },
    pentagonal_a: {
        icon: "M 26.5875,-2e-5 H -2e-5 V 50.00002 H 50.00002 V 23.4125 Z M 47.00021,25 V 47.00021 H 2.99979 V 2.9998 H 25 Z",
        path: "M 970,400 V 720 H 10 V 10 H 600 Z M 594,25 H 25 V 705 H 955 V 406 Z",
        viewBox: "0 0 980 730",
        patternTransform: "rotate(45) translate(15)",
        dimensions: [
            {prop: "a", position: "top", x: xhLeft, y: yhTop},
            {prop: "b", position: "right", x: xvRight, y: yvBottom},
            {prop: "c", position: "bottom", x: xhCenter, y: yhBottom},
            {prop: "d", position: "left", x: xvLeft, y: yvCenter},
        ]
    },
    pentagonal_b: {
        icon: "M -2.35e-5,23.4125 V 50.000024 H 50.000023 V -2.4e-5 H 23.412499 Z M 25.000003,2.999793 H 47.000211 V 47.000207 H 2.9997965 V 25 Z",
        path: "M 10,400 V 720 H 970 V 10 H 380 Z M 386,25 H 955 V 705 H 25 V 406 Z",
        viewBox: "0 0 980 730",
        patternTransform: "rotate(-45) translate(15)",
        dimensions: [
            {prop: "a", position: "top", x: xhRight, y: yhTop},
            {prop: "b", position: "right", x: xvRight, y: yvCenter},
            {prop: "c", position: "bottom", x: xhCenter, y: yhBottom},
            {prop: "d", position: "left", x: xvLeft, y: yvBottom},
        ]
    },
    pentagonal_c: {
        icon: "M 50.000025,26.587495 V -2.5e-5 H -2.5e-5 v 50.00005 h 26.58752 z m -25.00003,20.41271 H 2.999785 V 2.999795 h 44.00042 v 22.0002 z",
        path: "M 970,330 V 10 H 10 V 720 H 600 Z M 594,705 H 25 V 25 h 930 v 299 z",
        viewBox: "0 0 980 730",
        patternTransform: "rotate(-45) translate(15)",
        dimensions: [
            {prop: "a", position: "top", x: xhCenter, y: yhTop},
            {prop: "b", position: "right", x: xvRight, y: yvTop},
            {prop: "c", position: "bottom", x: xhLeft, y: yhBottom},
            {prop: "d", position: "left", x: xvLeft, y: yvCenter},
        ]
    },
    pentagonal_d: {
        icon: "m 23.412496,50.000025 h 26.58753 V -2.5e-5 H -2.6e-5 v 26.58753 z M 2.999794,24.999995 v -22.0002 h 44.000412 v 44.00041 h -22.00021 z",
        path: "M 10,330 V 10 H 970 V 720 H 380 Z M 386,705 H 955 V 25 H 25 v 299 z",
        viewBox: "0 0 980 730",
        patternTransform: "rotate(45) translate(15)",
        dimensions: [
            {prop: "a", position: "top", x: xhCenter, y: yhTop},
            {prop: "b", position: "right", x: xvRight, y: yvCenter},
            {prop: "c", position: "bottom", x: xhRight, y: yhBottom},
            {prop: "d", position: "left", x: xvLeft, y: yvTop},
        ]
    }
}
